import React from "react";
import { Header } from "../../features/kquant/components/Header";
import StrategiesDemoApp from "./StrategiesDemoApp";
import { useLocation } from "react-router-dom";

function getInitialPrompt(state: unknown): string | undefined {
  if (!state || typeof state !== "object") return undefined;
  const maybe = (state as { prompt?: unknown }).prompt;
  return typeof maybe === "string" ? maybe : undefined;
}

export default function StrategiesDemoPage() {
  const location = useLocation();
  const initialPrompt = getInitialPrompt(location.state);

  return (
    <div className="min-h-screen bg-[#f9fafb]">
      <div className="relative z-50 mx-auto max-w-[1280px] px-8">
        <Header />
      </div>

      <div style={{ height: "calc(100vh - 64px)" }}>
        <StrategiesDemoApp initialPrompt={initialPrompt} />
      </div>
    </div>
  );
}
